import React from "react";
import FilterSide from "../../../components/common/FilterSide";
import { arClass } from "../../../utils/useArClass";
import textTranslator from "../../../utils/useTextTranslator";

const WaitingRoomFilters = ({
  searchTerm,
  onSearchChange,
  filters,
  onFilterChange,
  onSortChange,
  onClearFilters,
  darkMode,
}) => {
  const panelWrapper = darkMode
    ? "bg-slate-800 border border-slate-700"
    : "bg-white border border-slate-200";

  return (
    <FilterSide
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      filters={filters}
      onFilterChange={onFilterChange}
      sortOptions={{ sorting: filters.sort }}
      onSortChange={onSortChange}
      onClearFilters={onClearFilters}
      darkMode={darkMode}
      searchPlaceholder={textTranslator(
        "Search patients, notes, positions, or IDs...",
        "WAITING_ROOM",
      )}
      filterTitle={textTranslator("Filter Waiting Room", "WAITING_ROOM")}
      className={arClass(`${panelWrapper} rounded-2xl shadow-sm p-4`)}
      filterOptions={{
        sections: [
          {
            key: "sort",
            label: "Sort By",
            type: "sort",
            options: [
              { value: "position-asc", label: "Position (1 → 9)" },
              { value: "position-desc", label: "Position (9 → 1)" },
              { value: "enteredAt-desc", label: "Newest first" },
              { value: "enteredAt-asc", label: "Oldest first" },
            ],
          },
        ],
      }}
      visibleColumns={null}
      onToggleColumn={() => {}}
      viewMode="grid"
    />
  );
};

export default WaitingRoomFilters;
